import { HttpClient } from "@angular/common/http";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { CookieHelperService } from "../../helper/cookie-helper.service";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { take } from "rxjs";

@Component({
    selector: "gem-google-map",
    templateUrl: "./gem-google-map.component.html",
    styleUrls: ["./gem-google-map.component.css"],
    standalone: false
})
export class GemGoogleMapComponent implements OnInit, OnChanges {
  @Input() googleApiKey: string;
  @Input() language: string;
  @Input() lat: string;
  @Input() lng: string;
  @Input() mapHeight: string;
  @Output() change: EventEmitter<any> = new EventEmitter();

  safeUrl: SafeUrl;

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private cookieHelperService: CookieHelperService,
  ) {}

  ngOnInit(): void {
    this.buildSafeUrl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildSafeUrl();
  }

  onEditCookies(): void {
    const ref: MatBottomSheetRef = this.cookieHelperService.openCookieSettings(false, false);
    ref
      .afterDismissed()
      .pipe(take(1))
      .subscribe(() => {
        this.change.emit();
      });
  }

  get isGoogleServicesContent(): boolean {
    return this.cookieHelperService.isGoogleServicesContent();
  }

  private buildSafeUrl(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          `https://www.google.com/maps/embed/v1/place?key=${this.googleApiKey}&q=${this.lat},${this.lng}&language=${this.language}`,
        );
  }
}
